<template>
    <div id="contact">
        <!-- banner -->
        <img class='banner' src="../assets/images/problem/banner.png" alt="">


        <div class="type_area contact">
            <!-- title -->
            <div class="title">
                <span>GET IN</span>
                <span class="color">TOUCH</span>
            </div>

            <!-- content -->
            <div class="content">
                <!-- img -->
                <div class="img">
                    <img src="../assets/images/contact/contact_1.png" alt="">
                </div>

                <!-- USA -->
                <div class="usa">
                    <p class="_title">USA</p>
                    
                    <!-- ADD -->
                    <div class="frame">
                        <span class="span">Add</span>
                        <p>{{addr}}</p>
                    </div>

                    <!-- Tel -->
                    <div class="frame">
                        <span class="span">Tel</span>
                        <p>{{phone}}</p>
                    </div>

                    <!-- Tel -->
                    <div class="frame">
                        <span class="span">E-mail</span>
                        <p>{{email}}</p>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
export default {
    data: function () {
        return {
            addr: "",
            phone: "",
            email: ""
        }
    },
    mounted() {
        this.$http.get("/api/contact.php").then((res)=>{
            this.addr = res.data.data[0].value;
            this.phone = res.data.data[1].value;
            this.email = res.data.data[2].value;
        })
    }
}
</script>


<style scoped lang="less">
    #contact{
        margin: 3rem 0 0;
        min-height: 45.5rem;
         // banner
        .banner{
            width:100%;
        }

        // title
        .title{
            margin: 1rem 0;
            text-align: center;
            font-weight: bold;
            .color{
                color:#257CE1;
                margin-left: 1rem;
            }
        }

        // content
        .content{
            display:flex;
            justify-content: center;
            flex-wrap:wrap;
            // 图片
            .img{
                width:90%;
                margin-top: 1rem;
                img{
                    width:100%;
                }
            }
            // USA
            .usa{
                width:90%;
                // height:18rem;
                box-shadow:3px 3px 5px rgba(168, 168, 166, 0.849);
                margin: 3rem 0 2rem;
                display:flex;
                justify-content: center;
                flex-wrap: wrap;
                // USA
                ._title{
                    width:100%;
                    color:#257CE1;
                    font-weight: bold;
                    font-size: 1.5rem;
                    text-align: center;
                    margin: 1rem 0;
                }

                // 框
                .frame{
                    width:80%;
                    height:6rem;
                    border:2px solid #ccc;
                    margin-bottom: 2rem;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0 1rem;
                    box-sizing: border-box;
                    position: relative;
                    .span{
                        padding: 0.5rem;
                        color:#257CE1;
                        font-weight: bold;
                        background:#fff;

                        position: absolute;
                        top: -10px;
                        left:-18px;
                    }
                    p{
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>